import { render } from "./ScButton.vue?vue&type=template&id=5690e29c&scoped=true"
import script from "./ScButton.vue?vue&type=script&lang=js"
export * from "./ScButton.vue?vue&type=script&lang=js"

import "./ScButton.vue?vue&type=style&index=0&id=5690e29c&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5690e29c"]])

export default __exports__